import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TeethComponent } from '@libs/perio';
import { Tooth } from '@libs/ui-lib';

@Component({
  selector: 'lib-perio-exam-review',
  imports: [TeethComponent],
  templateUrl: './perio-exam-review.component.html',
  styleUrl: './perio-exam-review.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioExamReviewComponent {
  public readonly teeth = input.required<Tooth[]>();
}
